function initErrorScroll() {

    let errorMessage = document.getElementById('AddEventDateForm_AddEventDateForm_error');

    if (errorMessage && errorMessage.classList.contains('bad')) {
        errorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

    let ExErrorMessage = document.getElementById('AddExhibitionProductForm_AddExhibitionProductForm_error');

    if (ExErrorMessage && ExErrorMessage.classList.contains('bad')) {
        ExErrorMessage.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }

}

export default initErrorScroll;
